module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_16.9172b507.pdf";